import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';
import { DurationPipe } from '@app/pipes/duration.pipe';

@Component({
  selector: 'app-agents-stats-widget',
  standalone: true,
  imports: [CommonModule, CardModule, SkeletonModule, DurationPipe],
  templateUrl: './agents-stats-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentsStatsWidget {
  durationSeconds = input<number>(0);
  loading = input<boolean>(false);
}
